import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetDocumentsPageDataInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

/**
 * Aggregate server function for the documents index page.
 *
 * Fetches documents list and business detail in a single HTTP round trip
 * on client-side navigation.
 */
export const getDocumentsPageData = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetDocumentsPageDataInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("documents.pageData", async () => {
      const [businessMod, documentMod] = await Promise.all([
        import("../business/business.server"),
        import("./document.server"),
      ]);
      const { getBusinessDetailForUser } = businessMod;
      const { listDocumentsForUser } = documentMod;

      const [businessDetail, documents] = await Promise.all([
        getBusinessDetailForUser(context.user.id, data.businessId),
        listDocumentsForUser(context.user.id, data.businessId, {
          limit: 20,
        }),
      ]);

      return { businessDetail, documents } as const;
    });
  });
